<template>
  <div>
    <el-dialog
      top="8vh"
      :before-close="handleClose"
      title="客户分群"
      custom-class="select-people-dialog"
      :visible.sync="visible"
      width="1150px"
    >
      <div slot="title" class="dialog-title">
        <span>客户分群</span>
        <!-- <el-button type="text">去创建人群</el-button> -->
      </div>
      <el-form
        :inline="true"
        :disabled="isReadOnly"
        label-width="80px"
        class="node-form"
      >
        <el-form-item label="节点名称" required>
          <el-input
            show-word-limit
            maxlength="50"
            class="show-limit"
            style="width: 320px"
            v-model="nodeName"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <div class="tab-wrap">
          <div class="tab-wrap-crowd">
            <el-checkbox v-model="isSplitCrowd" @change="changeSplitCrowd"
              >拆分每个人群为一个节点</el-checkbox
            >&nbsp;
            <el-tooltip
              class="item"
              effect="dark"
              content="不勾选时，选中的多个人群默认执行合并操作，勾选后，多个人群将按照每个人群拆分为一个节点"
              placement="right-start"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="人群列表" name="first"></el-tab-pane>
            <el-tab-pane
              :label="'已选择人群(' + newSelectList.length + ')'"
              name="second"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="activeName == 'first'">
          <div class="table-box" style="margin-top: 0">
            <!-- :row-key="rowKey" 分页保存，要有唯一的Id -->
            <el-form
              :inline="true"
              :disabled="isReadOnly"
              :model="crowdParams"
              label-width="68px"
            >
              <div
                style="
                  display: flex;
                  margin-bottom: 16px;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div>
                  <el-form-item label="人群名称" style="margin-bottom: 0">
                    <el-input
                      class="w-320"
                      v-model="crowdParams.name"
                      placeholder="人群名称/人群描述"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="人群类型" style="margin-bottom: 0">
                    <el-select
                      class="w-320"
                      v-model="crowdParams.type"
                      placeholder="请选择"
                      @change="handleChangeType"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="系统人群" :value="0"></el-option>
                      <el-option label="自定义人群" :value="1"></el-option>
                      <el-option label="数坊人群" :value="7"></el-option>
                      <el-option label="上传人群" :value="8"></el-option>
                      <el-option label="二次营销" :value="14"></el-option>
                      <el-option label="官方推荐人群" :value="9"></el-option>
                      <el-option label="行业专属人群" :value="10"></el-option>
                      <el-option label="定制人群" :value="11"></el-option>
                      <el-option label="运算人群" :value="12"></el-option>
                      <el-option label="互动人群" :value="13"></el-option>
                      <el-option label="官方人群" :value="15"></el-option>
                    </el-select>
                    <el-select
                      v-model="crowdParams.classifyId"
                      v-if="searchCrowdType == 1"
                      style="margin-left: 8px; width: 150px"
                    >
                      <el-option value="" label="全部"></el-option>
                      <el-option
                        v-for="(item, index) in classPeopleList"
                        :key="index"
                        :value="item.classifyId"
                        :label="item.name"
                      >
                        {{ item.name }}
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="crowdParams.classifyId"
                      v-else-if="searchCrowdType == 2"
                      style="margin-left: 8px; width: 150px"
                    >
                      <el-option value="" label="全部"></el-option>
                      <el-option :value="0" label="默认分组"></el-option>
                      <el-option
                        v-for="(item, index) in classPeopleList"
                        :key="index"
                        :value="item.classifyId"
                        :label="item.name"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <div class="button-group">
                    <el-button
                      size="small"
                      class="search"
                      @click="submitForm()"
                    >
                      <i
                        class="el-icon-search"
                        style="display: inline-block; width: 14px; height: 12px"
                      ></i>
                      查询
                    </el-button>
                    <el-button size="small" class="reset" @click="resetForm"
                      >重置</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form>
            <div class="btn_create" @click="toCreatePeople">
              <span>去创建人群</span>
            </div>
            <el-table
              ref="multipleTable"
              tooltip-effect="light"
              :data="crowdTableData"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              style="width: 100%; border: 1px solid #eee"
              stripe
              :row-key="
                (row) => {
                  return row.precisionCrowdStrategyId;
                }
              "
              :reserve-selection="true"
              v-loading="tableLoading"
            >
              <!-- <el-table-column
                :disabled="isReadOnly"
                type="selection"
                width="40"
                :reserve-selection="true"
                :selectable="checkSelectable"
            ></el-table-column> -->
              <el-table-column width="50px">
                <template slot="header" slot-scope="scope">
                  <el-checkbox v-model="allSelect" />
                </template>
                <template slot-scope="scope">
                  <label
                    v-if="(scope.row.count > 0 && scope.row.type != 15)
                    || (scope.row.type == 15 && scope.row.strategyOperateType == 1 && scope.row.count > 0)
                    || (scope.row.type == 15 && scope.row.strategyOperateType > 1 && scope.row.count > 20)"
                    @click="selectChange(scope.row)"
                    :class="{
                      'el-checkbox': 1,
                      'is-checked': newSelectList.some(
                        (c) =>
                          c.precisionCrowdStrategyId ===
                          scope.row.precisionCrowdStrategyId
                      ),
                    }"
                  >
                    <span
                      :class="{
                        'el-checkbox__input': 1,
                        'is-checked': newSelectList.some(
                          (c) =>
                            c.precisionCrowdStrategyId ===
                            scope.row.precisionCrowdStrategyId
                        ),
                      }"
                      ><span class="el-checkbox__inner"></span
                    ></span>
                  </label>
                  <label v-else>
                    <el-checkbox :disabled="true" />
                  </label>
                </template>
              </el-table-column>
              <template slot="empty">
                <div style="margin: 20px">
                  <img
                    :src="nodata"
                    style="
                      display: inline-block;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  <span class="nodata1">暂无数据</span>
                </div>
              </template>
              <!--  :reserve-selection="true"---分页保存数据     
                    :selectable="checkSelectable"---条件禁止    
              -->
              <el-table-column label="人群名称" prop="name"></el-table-column>
              <el-table-column label="人群人数" prop="count">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 14">
                    {{
                      scope.row.count == null
                        ? "0（生成中...）"
                        : scope.row.count
                    }}
                  </span>
                  <span v-else>{{ scope.row.count }}</span>
                </template>
              </el-table-column>
              <el-table-column label="人群类型">
                <template slot-scope="scope">
                  {{ scope.row.type | showType }}
                </template>
              </el-table-column>
              <el-table-column label="人群描述" prop="description">
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.description" placement="top">
                    <el-button class="buttom_tooltip">{{
                      scope.row.description
                    }}</el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createTime">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <!-- 2期 -->
              <el-table-column label="" prop="createTime" width="250px">
                <template slot-scope="scope" v-if="scope.row.isAdvanced">
                  <div>
                    <span>高级版专属人群</span>&nbsp;&nbsp;
                    <span
                      style="color: #fe4d45; cursor: pointer"
                      @click="upgrade"
                      >点击升级>></span
                    >
                  </div>
                </template>
              </el-table-column>
              <!-- end -->
            </el-table>
          </div>
          <!-- 分页器 -->
          <div class="block">
            <el-pagination
              background
              style="text-align: right; margin-top: 20px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="crowdParams.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="crowdParams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="crowdTotal"
            ></el-pagination>
          </div>
        </div>
        <div v-if="activeName == 'second'">
          <div class="table-box" style="margin-top: 0">
            <el-table
              ref="selectTable"
              tooltip-effect="light"
              :data="newSelectList"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              style="width: 100%; border: 1px solid #eee"
              stripe
              :row-key="
                (row) => {
                  return row.precisionCrowdStrategyId;
                }
              "
              :reserve-selection="true"
              v-loading="tableLoading"
            >
              <template slot="empty">
                <div style="margin: 20px">
                  <img
                    :src="nodata"
                    style="
                      display: inline-block;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  <span class="nodata1">暂无数据</span>
                </div>
              </template>
              <!--  :reserve-selection="true"---分页保存数据     
                      :selectable="checkSelectable"---条件禁止    
                -->
              <el-table-column label="人群名称" prop="name"></el-table-column>
              <el-table-column label="人群人数" prop="count">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 14">
                    {{
                      scope.row.count == null
                        ? "0（生成中...）"
                        : scope.row.count
                    }}
                  </span>
                  <span v-else>{{ scope.row.count }}</span>
                </template>
              </el-table-column>
              <el-table-column label="人群类型">
                <template slot-scope="scope">
                  {{ scope.row.type | showType }}
                </template>
              </el-table-column>
              <el-table-column label="人群描述" prop="description">
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.description" placement="top">
                    <el-button class="buttom_tooltip">{{
                      scope.row.description
                    }}</el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createTime">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    style="width: 40px"
                    type="text"
                    @click="selectChange(scope.row, false)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
              <!-- 2期 -->
              <el-table-column label="" prop="createTime" width="250px">
                <template slot-scope="scope" v-if="scope.row.isAdvanced">
                  <div>
                    <span>高级版专属人群</span>&nbsp;&nbsp;
                    <span
                      style="color: #fe4d45; cursor: pointer"
                      @click="upgrade"
                      >点击升级>></span
                    >
                  </div>
                </template>
              </el-table-column>
              <!-- end -->
            </el-table>
          </div>
        </div>
      </div>
      <div>
        <!-- 底部按钮 -->
        <div class="dialog-footer-btn">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button
            class="search"
            v-loading="loading"
            :disabled="isReadOnly"
            @click="handleConfirm"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
import { getMemberCrowd } from "@/api/marketing/memberCrowd";
import { queryCrowdClassify } from "@/api/manage/memberCrowdController";
export default {
  /*  选择人群弹窗 */
  name: "select-people",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    peopleList: {
      type: Array,
      default: () => [],
    },
    nodeId: Number,
    namingRules: {
      type: Number,
      default: 0,
    },
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    // 拆分节点配置
    isSplitCrowdConfig: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
    getNameLength: function () {
      return this.vipForm.name.length;
    },
    // 0 没有二级分类 1 有二级分类 2 有二级分类且可编辑/删除
    searchCrowdType() {
      if (
        this.crowdParams.type == 1 ||
        this.crowdParams.type == 12 ||
        this.crowdParams.type == 13
      ) {
        return 2;
      } else if (
        this.crowdParams.type === 0 ||
        this.crowdParams.type == 10 ||
        this.crowdParams.type == 11 ||
        this.crowdParams.type == 8 ||
        this.crowdParams.type == 15
      ) {
        return 1;
      } else {
        return 0;
      }
    },
    // 全选
    allSelect: {
      get() {
        const { crowdTableData, newSelectList } = this;
        // 当前页是否全选
        return crowdTableData.every((v) =>
          newSelectList.some(
            (c) => c.precisionCrowdStrategyId === v.precisionCrowdStrategyId
          )
        );
      },
      set(v) {
        console.log("row222", v);
        // 当前页设置全选
        this.crowdTableData.forEach((c) => {
          // 禁用状态不选择
          if (c.count > 0) {
            this.selectChange(c, v);
          }
        });
      },
    },
  },
  watch: {
    isSplitCrowdConfig: {
      handler: function (val) {
        this.isSplitCrowd = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      activeName: "first",
      flag: false,
      //多选回显
      isSplitCrowd: false,
      customerClusteringData: [],
      nodeIdName: "",
      multiChoice: [],
      nodata: require("@/assets/images/nodata.png"),
      btnImg: require("@/assets/images/btn_添加.svg"),
      crowdTableData: [],
      jumpUrl: "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=myarticle",
      tableLoading: false,
      crowdParams: {
        current: 1,
        size: 10,
        name: "",
        type: "",
        classifyId: "",
      },
      crowdTotal: 0,
      selectList: [],
      addGroup: [], // 当前页勾选的数据
      tableRadio: "",
      nodeName: "",
      loading: false,
      val: "",
      nodeNameDate: "",
      newSelectList: [],
      classPeopleList: [], // 人群类型二级分类
    };
  },
  mounted() {
    // 监听LocalStorage变化
    window.addEventListener("storage", (e) => {
      if (this.val != e.newValue) {
        this.getPeopleData();
      }
      this.val = e.newValue;
    });
    this.selectList = this.peopleList;
    this.getPeopleData();
    mnode
      .getNode({
        nodeId: this.nodeId,
      })
      .then((res) => {
        if (res.code == "1") {
          this.nodeName = res.data.name;
          this.nodeNameDate = res.data.name;
          // 拆分节点
          if (res.data.isSaveContent) {
            this.isSplitCrowd = false;
          }
          //多节点回显
          if (res.data.precisionCrowdStrategyId) {
            this.customerClusteringData = res.data.precisionCrowdStrategyId;
            this.getAllselect(this.customerClusteringData);
            let arr = [];
            let par = {};
            res.data.precisionCrowdStrategyId.forEach((e, index) => {
              par.precisionCrowdStrategyId = e;
              arr.push(par);
            });
            this.multiChoice = arr;
          }
        }
      });
  },
  methods: {
    changeSplitCrowd() {
      if (this.newSelectList.length == 1) {
        this.nodeName = this.newSelectList[0].name;
      } else if (this.newSelectList.length > 1) {
        this.nodeName =
          this.namingRules == 1 || this.isSplitCrowd
            ? this.newSelectList[this.newSelectList.length - 1].name
            : "客户分群";
      } else {
        this.nodeName = "客户分群";
      }
    },
    // checkbox的切换当前数据选中状态
    selectChange(row, check = null) {
      if (row.count !== 0) {
        console.log("row111", row);
        const { newSelectList: arr } = this;
        // 是否已选中
        const idx = arr.findIndex(
          (v) => v.precisionCrowdStrategyId === row.precisionCrowdStrategyId
        );
        // 传了选中状态就根据选中状态的来
        if (check !== null)
          check ? !~idx && arr.push(row) : ~idx && arr.splice(idx, 1);
        // 不传就有的就删，没有就加
        else ~idx ? arr.splice(idx, 1) : arr.push(row);

        //当名字是单独的时候做判断
        // if (this.newSelectList.length == 1) {
        //   this.nodeName = this.newSelectList[0].name;
        // } else {
        //   this.nodeName = '客户分群';
        // }
        if (this.newSelectList.length == 1) {
          this.nodeName = this.newSelectList[0].name;
        } else if (this.newSelectList.length > 1) {
          this.nodeName =
            this.namingRules == 1 || this.isSplitCrowd
              ? this.newSelectList[this.newSelectList.length - 1].name
              : "客户分群";
        } else {
          this.nodeName = "客户分群";
        }
      }
    },
    //禁止判断
    checkSelectable(row, index) {
      if (row.count == 0) {
        return false; //不可勾选
      } else {
        return true;
      }
    },
    //跳转到服务市场
    upgrade() {
      window.open(this.jumpUrl, "_blank");
    },
    toCreatePeople() {
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/grouping?create=1",
      });
      window.open(routeUrl.href, "_blank");
    },
    updateNodeName(row, id) {
      //当名字是单独的时候做判断
      if (row.length == 1) {
        this.nodeName = row[0].name;
      } else {
        this.nodeName = this.nodeNameDate;
      }
      this.multiChoice = row;
    },
    handleConfirm() {
      if (this.nodeName.length > 50) {
        return this.$message.error("节点名称不能超过50个字符");
      }
      if (this.loading) {
        return;
      }
      //人群选择节点格式转换
      const multiChoiceFormat = [];
      this.newSelectList.forEach((e) => {
        if (this.newSelectList)
          multiChoiceFormat.push(e.precisionCrowdStrategyId);
      });
      if (this.newSelectList.length > 1 && this.isSplitCrowd) {
        this.nodeName = this.newSelectList[0].name;
      }

      let param = {
        name: this.nodeName,
        nodeId: this.nodeId,
        precisionCrowdStrategyId: multiChoiceFormat,
      };
      param.isSplitCrowd = this.isSplitCrowd;
      this.loading = true;
      mnode.updateDetail(param).then((res) => {
        this.loading = false;
        if (res.code === 1) {
          // this.viewVisible = false;
          this.$emit("change-name", param);
          this.$emit("changeInit");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //查询人群接口
    submitForm() {
      this.getPeopleData();
    },
    //重置接口
    resetForm() {
      this.crowdParams = {
        current: 1,
        size: 10,
        name: "",
        type: "",
        classifyId: "",
      };
      this.getPeopleData();
    },
    // 获取人群选择列表
    getPeopleData() {
      this.tableLoading = true;
      getMemberCrowd({
        ...this.crowdParams,
        description: this.crowdParams.name,
      }).then((res) => {
        this.tableLoading = false;
        this.crowdTableData = res.data.records;
        this.crowdTotal = +res.data.total;
        this.$nextTick(() => {
          var selectList = this.customerClusteringData;
          console.log(
            "this.customerClusteringData",
            this.customerClusteringData
          );
          // this.crowdTableData.forEach((row) => {
          //   console.log(row.precisionCrowdStrategyId);
          //   for (var i = 0; i < selectList.length; i++) {
          //     //多选节点回显，
          //     if (row.precisionCrowdStrategyId == selectList[i]) {
          //       this.$refs.multipleTable.toggleRowSelection(row, true);
          //     }
          //   }
          // });
        });
      });
    },
    getAllselect(ids) {
      if (ids && ids.length > 0) {
        this.tableLoading = true;
        getMemberCrowd({
          crowdIds: ids.toString(),
          size: "9999",
          current: "1",
        }).then((res) => {
          this.tableLoading = false;
          this.newSelectList = res.data.records;
        });
      }
    },
    handleSizeChange(val) {
      this.crowdParams.size = val;
      this.getPeopleData();
    },
    handleCurrentChange(val) {
      this.crowdParams.current = val;
      this.getPeopleData();
    },
    handleClose() {
      this.viewVisible = false;
    },
    handleChangeType() {
      this.crowdParams.classifyId = "";
      if (this.searchCrowdType) {
        queryCrowdClassify(this.crowdParams.type).then((res) => {
          this.classPeopleList = res.data;
        });
      }
    },

    handleClick() {},
  },
  filters: {
    showType: function (val) {
      var result = "";
      if (val == "1") {
        result = "自定义分组";
      } else if (val == "2") {
        result = "筛选条件人群包";
      } else if (val == "0") {
        result = "系统分组";
      } else if (val == "8") {
        result = "上传人群";
      } else if (val == "9") {
        result = "官方推荐人群";
      } else if (val == "10") {
        result = "行业专属人群";
      } else if (val == "11") {
        result = "定制人群";
      } else if (val == "12") {
        result = "运算人群";
      } else if (val == "13") {
        result = "互动人群";
      } else if (val == "14") {
        result = "二次营销";
      } else if (val == "15") {
        result = "官方人群";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.buttom_tooltip {
  border: none;
  background-color: transparent;
  text-align: left;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    background-color: transparent;
    color: #666;
  }
}
/deep/ .el-table__body-wrapper {
  height: 280px;
  overflow-y: auto;
}
// 选择人群弹窗
.select-people-dialog {
  .table-box {
    overflow: auto;
  }
  .dialog-title {
    span {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
      .el-button {
        font-size: 14px;
      }
    }
  }
  .search-line {
    margin-bottom: 24px;
    .el-input {
      width: 280px;
      margin-right: 20px;
    }
  }
  .button-group {
    display: inline-block;
    .search {
      width: 98px;
      height: 32px;
      color: #fe4d45;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #dddddd;

      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .dialog-footer-btn {
    text-align: center;
    margin-top: 30px;
    .search {
      width: 98px;
      height: 32px;
      color: #ffffff;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      margin: 0px 0px 0 800px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .btn_create {
    color: #7f85e9;
    width: 98px;
    display: flex;
    align-items: center;
    // line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    cursor: pointer;
    margin-bottom: 16px;
  }
}
.tab-wrap {
  position: relative;
  &-crowd {
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 10;
    display: flex;
    align-items: center;
  }
  /deep/ .el-tabs__header {
    margin-bottom: 16px;
  }
}
.node-form {
  /deep/ .el-form-item {
    margin-bottom: 8px;
  }
  .show-limit {
    /deep/.el-input__inner {
      padding-right: 50px !important;
    }
  }
}
.w-320 {
  width: 320px;
}
</style>
